import type { DataAwareResponse } from "@/types/types";
import { axiosInstance } from "@helpers/axios-instance";
import { useQueryWithValidation } from "./useQueryWithValidation";

export type FinancialAccountsHolding = {
  externalCode: string;
  amount: number | string;
  displayName?: string;
};

type Props = {
  accountExternalCode: string;
  enabled: boolean;
};

export function useAccountsHeldElsewhereHoldings({ accountExternalCode, enabled }: Props) {
  return useQueryWithValidation({
    queryKey: ["ahe-holdings", accountExternalCode],
    queryFn: async () => {
      const data = await axiosInstance({
        method: "GET",
        url:
          
          `Salesforce/AccountsHeldElsewhereHoldings/${accountExternalCode}`,
      });
      return data.data as DataAwareResponse<FinancialAccountsHolding[]>;
    },
    enabled: !!accountExternalCode && enabled,
  });
}
